import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bcd6574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-dsr" }
const _hoisted_2 = { class: "nge-dsr-head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Dataset requests", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-dsr-sub" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-dsr-how" }, [
  /*#__PURE__*/_createTextVNode(" Players asking for one dataset (not retina, which has its own request below). For MEC, "),
  /*#__PURE__*/_createElementVNode("b", null, "Grant"),
  /*#__PURE__*/_createTextVNode(" adds them to MEC_Edit in CAVE and then tells them they're in. For other datasets, add them to the dataset's group in CAVE yourself, then press "),
  /*#__PURE__*/_createElementVNode("b", null, "Grant"),
  /*#__PURE__*/_createTextVNode(". ")
], -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  class: "nge-dsr-err",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "nge-dsr-how"
}
const _hoisted_10 = { class: "nge-dsr-line" }
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = { class: "nge-dsr-ds" }
const _hoisted_13 = {
  key: 0,
  class: "nge-dsr-cave"
}
const _hoisted_14 = { class: "nge-dsr-when" }
const _hoisted_15 = { class: "nge-dsr-meta" }
const _hoisted_16 = {
  key: 0,
  class: "nge-dsr-access"
}
const _hoisted_17 = {
  key: 1,
  class: "nge-dsr-meta nge-dsr-none"
}
const _hoisted_18 = {
  key: 2,
  class: "nge-dsr-history"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "nge-dsr-none"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  key: 3,
  class: "nge-dsr-note"
}
const _hoisted_23 = { class: "nge-dsr-actions" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["disabled", "title", "onClick"]
const _hoisted_26 = ["disabled", "title", "onClick"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = { class: "nge-dsr-ds" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "nge-dsr-when" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $setup.lockIcon,
        class: "nge-dsr-icon",
        alt: "",
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, _hoisted_3),
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.waiting.length) + " waiting", 1 /* TEXT */),
      _createElementVNode("button", {
        class: "nge-dsr-btn nge-dsr-refresh",
        disabled: $setup.loading,
        onClick: $setup.load
      }, "Refresh", 8 /* PROPS */, _hoisted_6)
    ]),
    _hoisted_7,
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.error), 1 /* TEXT */))
      : (!$setup.loading && !$setup.waiting.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Nobody is waiting."))
        : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waiting, (r) => {
      return (_openBlock(), _createElementBlock("article", {
        key: r.id,
        class: "nge-dsr-row"
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "nge-dsr-name",
            disabled: !r.userId,
            title: "Open their profile",
            onClick: $event => ($setup.openProfile(r))
          }, _toDisplayString(r.name || r.email), 9 /* TEXT, PROPS */, _hoisted_11),
          _createElementVNode("span", _hoisted_12, [
            _createTextVNode(_toDisplayString(r.label), 1 /* TEXT */),
            (r.cave)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " · CAVE " + _toDisplayString(r.cave), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.when(r.at)), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(r.email), 1 /* TEXT */),
        (r.access)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.WATCHED, (w) => {
                return _createElementVNode("span", {
                  key: w.cave,
                  class: _normalizeClass(["nge-dsr-chip", 'nge-dsr-chip--' + $setup.levelOf(r.access, w.cave)])
                }, _toDisplayString(w.name) + ": " + _toDisplayString($setup.LEVEL_WORDS[$setup.levelOf(r.access, w.cave)]), 3 /* TEXT, CLASS */)
              }), 64 /* STABLE_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, "Their CAVE access could not be read.")),
        (r.history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (r.history.joined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "On Pyr " + _toDisplayString($setup.since(r.history.joined)) + " (joined " + _toDisplayString($setup.day(r.history.joined)) + ")", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (!$setup.watchedEdits(r.history).length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "No Retina or MEC edits yet"))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.watchedEdits(r.history), (h) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: h.dataset,
                  title: 'First edit ' + $setup.day(h.first) + ', latest ' + $setup.day(h.last)
                }, _toDisplayString($setup.tagName(h.dataset)) + ": editing " + _toDisplayString($setup.since(h.first)) + ", last " + _toDisplayString($setup.since(h.last) === 'today' ? 'today' : $setup.since(h.last) + ' ago'), 9 /* TEXT, PROPS */, _hoisted_21))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (r.note)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, "“" + _toDisplayString(r.note) + "”", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => (($setup.notes[r.id]) = $event),
            class: "nge-dsr-input",
            maxlength: "500",
            placeholder: "A note for them (optional)"
          }, null, 8 /* PROPS */, _hoisted_24), [
            [_vModelText, $setup.notes[r.id]]
          ]),
          (r.caveGroup)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "nge-dsr-btn nge-dsr-btn--yes",
                disabled: $setup.busy === r.id,
                title: `Add them to ${r.caveGroup} in CAVE, then tell them they're in`,
                onClick: $event => ($setup.decide(r, 'granted'))
              }, _toDisplayString($setup.busy === r.id ? 'Granting…' : `Grant (adds to ${r.caveGroup})`), 9 /* TEXT, PROPS */, _hoisted_25))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-dsr-btn", { 'nge-dsr-btn--yes': !r.caveGroup }]),
            disabled: $setup.busy === r.id,
            title: r.caveGroup ? 'You already added them in CAVE yourself: just tell them' : 'Add them to the dataset\'s group in CAVE first, then press this to tell them',
            onClick: $event => ($setup.decide(r, 'granted', true))
          }, _toDisplayString(r.caveGroup ? 'I added them by hand' : 'Grant'), 11 /* TEXT, CLASS, PROPS */, _hoisted_26),
          _createElementVNode("button", {
            class: "nge-dsr-btn",
            disabled: $setup.busy === r.id,
            onClick: $event => ($setup.decide(r, 'declined'))
          }, "Not now", 8 /* PROPS */, _hoisted_27)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($setup.answered.length)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "nge-dsr-toggle",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.showAnswered = !$setup.showAnswered))
        }, _toDisplayString($setup.showAnswered ? '▾' : '▸') + " Answered (" + _toDisplayString($setup.answered.length) + ") ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.showAnswered)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList($setup.answered, (r) => {
          return (_openBlock(), _createElementBlock("div", {
            key: r.id,
            class: "nge-dsr-done"
          }, [
            _createElementVNode("button", {
              class: "nge-dsr-name",
              disabled: !r.userId,
              title: "Open their profile",
              onClick: $event => ($setup.openProfile(r))
            }, _toDisplayString(r.name || r.email), 9 /* TEXT, PROPS */, _hoisted_28),
            _createElementVNode("span", _hoisted_29, _toDisplayString(r.label), 1 /* TEXT */),
            _createElementVNode("span", {
              class: _normalizeClass(["nge-dsr-mark", `nge-dsr-mark--${r.mark}`])
            }, [
              _createElementVNode("img", {
                src: r.mark === 'granted' ? $setup.unlockIcon : $setup.lockIcon,
                class: "nge-dsr-mark-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, _hoisted_30),
              _createTextVNode(_toDisplayString(r.mark === 'granted' ? 'Granted' : 'Not now'), 1 /* TEXT */)
            ], 2 /* CLASS */),
            _createElementVNode("span", _hoisted_31, _toDisplayString($setup.when(r.markedAt)) + _toDisplayString(r.markedBy ? ` by ${r.markedBy}` : ''), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}